import { GetStaticPaths, GetStaticProps } from 'next';

import { withEventScope } from '@repo/event-processor';

import { CreateSubUseCaseStrapiPage } from 'strapi/page/createSubUseCasePage';
import LandingPageStrapi from 'strapi/page/LandingPageStrapi';
import { PageType } from 'strapi/page/types';
import { getStrapiLandingPageStaticProps } from 'strapi/utils';

export const getStaticProps: GetStaticProps = async (context) => {
  if (
    typeof context.params?.useCaseUid !== 'string' ||
    typeof context.params?.subUseCaseUid !== 'string'
  ) {
    return { notFound: true };
  }

  const strapiPageParams =
    await getStrapiLandingPageStaticProps<CreateSubUseCaseStrapiPage>(
      `/create/${context.params?.useCaseUid}/${context.params?.subUseCaseUid}`,
      PageType.CreateSubUseCasePage
    );

  if ('notFound' in strapiPageParams) {
    return { notFound: true };
  }

  return {
    props: { params: strapiPageParams, pageType: 'strapi' },
  };
};

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export default withEventScope(LandingPageStrapi, { page: 'landingPage' });
